import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'livrare',
    [ORDER_METHODS.PICKUP]: 'ridicare',
    [ORDER_METHODS.ON_SITE]: 'masă',
  },
  feedback: {
    payment_method_disabled: 'Nu acceptăm plăți {{paymentMethod}} pentru comenzile de {{orderMethod}}',
    cash_disabled: 'Nu acceptăm plăți în numerar pentru comenzile de {{orderMethod}}',
  },
};
